import { render } from "./yearbook.vue?vue&type=template&id=3940ff9d&scoped=true"
import script from "./yearbook.vue?vue&type=script&lang=js"
export * from "./yearbook.vue?vue&type=script&lang=js"

import "./yearbook.vue?vue&type=style&index=0&id=3940ff9d&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3940ff9d"]])

export default __exports__